import React from "react";
import styles from "../About/AboutUs.module.css";
import { Container, Grid } from "@mui/material";
import { welcometext } from "../../Constants";

const Welcome = () => {
  return (
    <section className={styles.welcomemainwrap}>
      <Container maxWidth="xl">
        <div style={{ padding: "0 28px" }}>
          <Grid container className={styles.featuresmainwrap}>
            <Grid item xs={12}>
              <div className={styles.welcometitle}>{welcometext.title}</div>
              <div className={styles.welcometext}>{welcometext.subTitle}</div>
            </Grid>
          </Grid>
        </div>
      </Container>
    </section>
  );
};

export default Welcome;
